import {
  PRODUCT_REVIEW_SUMMARY_BATCH_SIZE,
  type ProductReviewSummary,
  parseProductReviewSummaries,
} from './product-reviews'

export function chunkProductReviewSummaryIds(publicIds: readonly number[]) {
  const chunks: number[][] = []
  for (let index = 0; index < publicIds.length; index += PRODUCT_REVIEW_SUMMARY_BATCH_SIZE) {
    chunks.push(publicIds.slice(index, index + PRODUCT_REVIEW_SUMMARY_BATCH_SIZE))
  }
  return chunks
}

export async function fetchProductReviewSummaryBatch(
  publicIds: readonly number[]
): Promise<Record<string, ProductReviewSummary>> {
  if (!publicIds.length || publicIds.length > PRODUCT_REVIEW_SUMMARY_BATCH_SIZE) {
    throw new Error(
      `Product rating batches must contain between 1 and ${PRODUCT_REVIEW_SUMMARY_BATCH_SIZE} IDs`
    )
  }

  const params = new URLSearchParams({ ids: publicIds.join(',') })
  const response = await fetch(`/api/trusted/experiences/summaries/?${params}`)
  if (!response.ok) throw new Error('Product ratings unavailable')

  return parseProductReviewSummaries(await response.json(), publicIds)
}
